/*
 * VTee PC ヘッダー: プライオリティナビ (オーバーフロー "More")
 * ─ カテゴリメニュー(.vtee-mega-menu__list) と その他リンク(.vtee-header-links) を
 *   1つの並びに統合し、横幅に入りきらない分を右端から順に "More" へ畳む。
 *   (例: About VTee → LookBook → PANTS → OUTERWEAR ... の順に隠れる)
 * ─ カテゴリ群 と その他リンク群 の間には区切り線を表示。両側に可視項目がある時だけ表示。
 * ─ リサイズで再計算。990px 未満(モバイル)では無効。
 */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 990px)';
  function isDesktop() {
    return !!(window.matchMedia && window.matchMedia(DESKTOP).matches);
  }

  var CARET =
    '<svg class="vtee-mega-menu__caret" viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
    '<path d="m2,4.5 4,4 4,-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg>';

  function build(row) {
    var nav = row.querySelector('.vtee-mega-menu');
    var list = nav && nav.querySelector('.vtee-mega-menu__list');
    if (!list) return null;

    // 1) その他リンクを list に取り込む: [divider] + [other items]
    var divider = null;
    var otherNav = row.querySelector('.vtee-header-links');
    if (otherNav) {
      var anchors = [].slice.call(otherNav.querySelectorAll('.vtee-header-links__item'));
      if (anchors.length) {
        divider = document.createElement('li');
        divider.className = 'vtee-mega-menu__item vtee-mega-menu__divider';
        divider.setAttribute('aria-hidden', 'true');
        divider.innerHTML = '<span class="vtee-header-links__divider"></span>';
        list.appendChild(divider);

        anchors.forEach(function (a) {
          var li = document.createElement('li');
          li.className = 'vtee-mega-menu__item vtee-mega-menu__item--other';
          a.classList.add('vtee-mega-menu__link'); // 行内・More内で共通スタイル
          li.appendChild(a);
          list.appendChild(li);
        });
      }
      otherNav.parentNode && otherNav.parentNode.removeChild(otherNav);
    }

    // 2) 元の並び (More を除く全項目) を記録 → reset 時にこの順で戻す
    var originalItems = [].slice.call(list.children);

    // 3) "More" 項目
    var moreItem = document.createElement('li');
    moreItem.className = 'vtee-mega-menu__item vtee-mega-menu__item--more';
    moreItem.style.display = 'none';
    moreItem.innerHTML =
      '<details class="vtee-mega-menu__details">' +
      '<summary class="vtee-mega-menu__link vtee-mega-menu__link--parent"><span>More</span>' +
      CARET +
      '</summary>' +
      '<div class="vtee-mega-menu__panel vtee-mega-menu__panel--more">' +
      '<div class="vtee-mega-menu__panel-inner">' +
      '<ul class="vtee-header-more__list" role="list"></ul>' +
      '</div></div></details>';
    list.appendChild(moreItem);

    return {
      list: list,
      moreItem: moreItem,
      moreList: moreItem.querySelector('.vtee-header-more__list'),
      details: moreItem.querySelector('details'),
      divider: divider,
      originalItems: originalItems,
    };
  }

  function reflow(ctx) {
    var list = ctx.list,
      moreItem = ctx.moreItem,
      moreList = ctx.moreList;

    // 1) reset: 記録した元の順で全項目を list に戻し、More を隠す
    ctx.originalItems.forEach(function (el) {
      list.insertBefore(el, moreItem);
    });
    moreItem.style.display = 'none';
    if (ctx.details) ctx.details.open = false;
    if (ctx.divider) ctx.divider.style.display = '';

    if (!isDesktop()) return;

    // 2) 収まっているなら区切り線だけ調整して終了
    if (list.scrollWidth <= list.clientWidth + 1) {
      adjustDivider(ctx);
      return;
    }

    // 3) More 幅を確保
    moreItem.style.display = '';
    var moreW = moreItem.getBoundingClientRect().width || 72;
    var listRect = list.getBoundingClientRect();
    var limit = listRect.left + list.clientWidth - moreW;

    // 4) 右端座標で判定 (gap 込み)。divider 以外の項目を右から順に More へ。
    var candidates = ctx.originalItems.filter(function (el) {
      return el !== ctx.divider;
    });
    var rights = candidates.map(function (el) {
      return el.getBoundingClientRect().right;
    });
    var moved = false;
    candidates.forEach(function (el, i) {
      if (rights[i] > limit) moved = true;
      if (moved) moreList.appendChild(el);
    });

    if (!moreList.children.length) moreItem.style.display = 'none';

    adjustDivider(ctx);
  }

  // 区切り線のルール:
  //  カテゴリ群 と その他リンク群 の「両方」が同じ場所に並んでいる時、その境界に表示。
  //   1) 行(list 直下) に 可視カテゴリ と 可視その他リンク が両方ある → 行内の境界に
  //   2) それが無く、More パネル内に カテゴリ と その他リンク が両方ある → パネル内の境界に
  //      (例: 開いた More が「PANTS ｜ LookBook About VTee」)
  //   3) どちらでもない (片側だけ) → 非表示
  function adjustDivider(ctx) {
    var div = ctx.divider;
    if (!div) return;
    var list = ctx.list,
      moreItem = ctx.moreItem,
      moreList = ctx.moreList;

    function firstOther(container) {
      var kids = container.children;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i] !== div && kids[i].classList.contains('vtee-mega-menu__item--other')) return kids[i];
      }
      return null;
    }
    function hasCategory(container) {
      var kids = container.children;
      for (var i = 0; i < kids.length; i++) {
        var el = kids[i];
        if (el === div || el === moreItem) continue;
        if (
          !el.classList.contains('vtee-mega-menu__item--other') &&
          !el.classList.contains('vtee-mega-menu__item--more')
        )
          return true;
      }
      return false;
    }

    // 1) 行内に両方
    var rowOther = firstOther(list);
    if (rowOther && hasCategory(list)) {
      list.insertBefore(div, rowOther);
      div.style.display = '';
      return;
    }
    // 2) More パネル内に両方
    var panelOther = firstOther(moreList);
    if (panelOther && hasCategory(moreList)) {
      moreList.insertBefore(div, panelOther);
      div.style.display = '';
      return;
    }
    // 3) 片側だけ → 非表示
    div.style.display = 'none';
  }

  function init() {
    var row = document.querySelector('.vtee-header-menu-row');
    if (!row) return;
    var ctx = build(row);
    if (!ctx) return;

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        reflow(ctx);
      });
    }

    schedule();
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
